import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  grid-gap: 32px;
  align-items: center;
  justify-content: center;
  width: 100%;

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    grid-gap: unset;
    justify-content: space-evenly;
  }
`;

export const Icon = styled.svg`
  height: 30px;
  width: 30px;

  color: ${props => props.theme.old.colors.white};
  transition: ${props => props.theme.old.transition.default};
  cursor: pointer;

  :hover{
    opacity: .5;
  }

  ${({ theme }) => theme.old.breakpoints.isMobile} {
    height: 25px;
    width: 25px;
  }
`;
